import { NavLink } from "react-router-dom";

export default function NavBarMain() {

    var backEnabled = false;
    //var title = "Test";
    //var navItems = [
    //    { id: "home", title: "Info", icon: null, active: true },
    //    { id: "packageSizes", title: "Package Sizes", icon: null, active: false },
    //    { id: "rates", title: "Rates", icon: null, active: false },
    //    { id: "windows", title: "Windows", icon: null, active: false },
    //    { id: "settings", title: "", icon: "fas fa-cog", active: false }
    //];

    var search = window.location.search;

    return (
        <div id="nav-top">
            {backEnabled
                ? <i className="fa fa-chevron-left" onclick="window.history.back();"></i>
                : <img alt="Logo" className="logo" src="/images/Logo.png"></img>
            }
            <nav>
                <NavLink to={`/${search}`}>Info</NavLink>
                <NavLink to={`PackageSizes${search}`}>Package Sizes</NavLink>
                <NavLink to={`Rates${search}`}>Rates</NavLink>
                <NavLink to={`Windows${search}`}>Windows</NavLink>
                <NavLink to={`Settings${search}`}><i className="fas fa-cog"></i></NavLink>
            </nav>
        </div>
    );
}